import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-darker px-6 pt-20 pb-16 md:pt-32 md:pb-24" data-id="element-68">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-brand-gold/10 blur-[80px] rounded-full pointer-events-none" data-id="element-69"></div>

      <div className="mx-auto max-w-6xl relative z-10" data-id="element-70">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-71">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col gap-6 text-center lg:text-left" data-id="element-72">
            <div className="inline-block mx-auto lg:mx-0 rounded-full bg-brand-gold/10 px-4 py-1.5 border border-brand-gold/20" data-id="element-73">
              <span className="text-brand-gold font-semibold text-sm tracking-wide uppercase" data-id="element-74">
                Solo para Networkers en Español
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] text-white" data-id="element-75">
              Tu Lista se Agotó. Tu Método Está Roto.{' '}
              <span className="text-brand-gold" data-id="element-76">
                Esto te Saca del Estancamiento en 7 Días.
              </span>
            </h1>

            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-77">
              Instala el Sistema Magnético en tu perfil de Instagram y recibe tu
              primer mensaje de prospecto calificado antes del Día 7, sin
              perseguir a tu familia, sin mensajes en frío y sin importar
              cuántos seguidores tengas hoy.
            </p>

            <p className="text-sm text-slate-400 flex items-center justify-center lg:justify-start gap-1.5" data-id="element-78">
              <span className="text-amber-400" data-id="element-79">⭐⭐⭐⭐⭐</span>
              <span data-id="element-80">
                Más de 847 Networkers ya activaron su Sistema Magnético
              </span>
            </p>

            {/* Mobile-only product image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="block lg:hidden mx-auto w-full max-w-xs" data-id="element-81">
              <div className="relative aspect-[4/5] w-full" data-id="element-82">
                <img src="https://cdn.magicpatterns.com/uploads/x7PePMgMreZkAWBkqgaZhg/mockup_libro.png" alt="Networker Magnético - Plan de 7 Días" width={320} height={400} decoding="async" className="object-contain w-full h-full drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-83" />
              </div>
            </motion.div>

            <div className="mt-4 flex flex-col items-center lg:items-start gap-4" data-id="element-84">
              <CTAButton text="SÍ, QUIERO SALIR DEL ESTANCAMIENTO AHORA — $17" data-id="element-85" />
              <p className="text-sm text-slate-500 flex items-center gap-2" data-id="element-86">
                <span className="flex h-2 w-2 rounded-full bg-green-500" data-id="element-87"></span>
                Acceso inmediato y seguro
              </p>
            </div>
          </motion.div>

          {/* Desktop-only product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="hidden lg:block relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-88">
            <div className="relative aspect-[4/5] w-full" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/x7PePMgMreZkAWBkqgaZhg/mockup_libro.png" alt="Networker Magnético - Plan de 7 Días" width={500} height={625} decoding="async" className="object-contain w-full h-full drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-90" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}